'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _DropDown = require('../DropDown');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The GroupedDropDown component displays the list of options in the dropdown in groups. The groups are defined
 * by adding a 'groupName' key and value to each item that is bound to the dropdown.
 *
 * The list of props are the same as the DropDown except there is a change in the data prop.
 */
var GroupedDropDownBase = function (_React$Component) {
  _inherits(GroupedDropDownBase, _React$Component);
  function GroupedDropDownBase() {
    _classCallCheck(this, GroupedDropDownBase);
    return _possibleConstructorReturn(this, (GroupedDropDownBase.__proto__ || Object.getPrototypeOf(GroupedDropDownBase)).apply(this, arguments));
  }
  _createClass(GroupedDropDownBase, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(_DropDown.DropDown, this.props);
      }
      return render;
    }()
  }]);
  return GroupedDropDownBase;
}(_react2['default'].Component);
GroupedDropDownBase.propTypes = {
  /**
   * To display items in groups, each item in the data array should be tagged with a groupName
   * key value pair. Each item with the same groupName value will be displayed as part of the group.
   *
   * Sample data array:
   *
   * ```json
   * [
   *     { name: 'one', value: '1', groupName: 'First' },
   *     { name: 'two', value: '2', groupName: 'First' },
   *     { name: 'three', value: '3', groupName: 'First' },
   *     { name: 'four', value: '4', groupName: 'Second' },
   *     { name: 'five', value: '5', groupName: 'Second' }
   * ]
   * ```
   */
  data: _propTypes2['default'].array
};
GroupedDropDownBase.displayName = 'GroupedDropDown';
exports['default'] = GroupedDropDownBase;